export * from './simple-layout.component';



// WEBPACK FOOTER //
// /app/src/app/containers/simple-layout/index.ts